import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { TenantUtilities } from "@core/utilities";
import { KioskContextService } from "@core/services/kiosk-context.service";

export function validDeviceGuard(): CanActivateFn {
  return (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const router: Router = inject(Router);
    const kioskContextService: KioskContextService = inject(KioskContextService);
    
    const deviceKey = kioskContextService.deviceKey();
    if (!deviceKey) {
      // No device key found, redirect to unauthorized page
      const tenantId = TenantUtilities.getTenantFromRoute() || TenantUtilities.default_tenant;
      const unauthorizedUrl: UrlTree = router.parseUrl(`/${tenantId}/kiosk/unauthorized`);
      return unauthorizedUrl;
    }
    
    // Device key exists, allow access
    return true;
  };
}
